import { FormControl, ValidationErrors } from '@angular/forms';

export function imageType(control: FormControl): ValidationErrors | null {
  const value = control?.value;

  // An empty value is not a wrong format — leave emptiness to `required`,
  // otherwise an optional/untouched upload shows a bogus format error.
  if (value === null || value === undefined || value === '') {
    return null;
  }

  // Strip any query (?v=<cache-bust timestamp>) or fragment before checking the
  // extension — stored image paths come back as `.../photo.png?v=1737…`, and the
  // raw suffix check would otherwise reject a perfectly valid existing image and
  // block the edit form from saving.
  const path = String(value).toLowerCase().split('?')[0].split('#')[0];

  if (/\.(jpe?g|png)$/.test(path)) {
    return null;
  }

  return { imageType: true };
}
